import React, { useState, useEffect } from "react";

// Component
import Table, { TableRow } from "../../../component/table";
import PageSelector from "../../../component/PageSelector";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import Loader from "react-spinner-loader";
import { useNavigate } from "react-router-dom";
import RowsPerPageSelector from "../../../component/RowsPerPageSelector";

// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  getSKUDataList,
  deleteSKUMaster,
} from "../../../redux/actions/skuMaster";

function SKUTable({ debouncedHandleSearch }) {
  const navigate = useNavigate();

  // state
  const [page, setPage] = useState(1);
  const [tableLoader, setTableLoader] = useState(false);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [sort, setSort] = useState();
  const [update, setUpdate] = useState(1);

  // Redux
  const dispatch = useDispatch();
  const { sku_data_list } = useSelector((state) => state.skuMaster);
  const { row_count } = useSelector((state) => state.auth);

  // Funtion to call GET API of SKU list
  const getSKUMasterList = () => {
    setTableLoader(true);
    const request = {
      onSuccess: () => {
        setTableLoader(false);
      },
      onError: (error) => {
        setTableLoader(false);
      },
    };
    dispatch(
      getSKUDataList(
        request,
        page,
        debouncedHandleSearch,
        sortOrder,
        sortField,
        row_count
      )
    );
  };

  useEffect(() => {
    getSKUMasterList();
  }, [update, page, debouncedHandleSearch, sortOrder, sortField, row_count]);

  /*--------- Sorting SKU ------------ */
  useEffect(() => {
    if (sort) {
      setPage(1);
      setSortField(sort.headName);
      setSortOrder(sort.type);
    }
  }, [sort]);

  // Funtion to DELETE SKU
  const handleDelete = (id) => {
    const request = {
      sku_id: id,
      onSuccess: () => {
        setUpdate(update + 1);
      },
      onError: (error) => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={error?.message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(deleteSKUMaster(request));
  };

  return (
    <div className="">
      <Table
        heads={[
          { headName: "SKU Name", isSort: true, value: "sku_name" },
          { headName: "SKU Number", isSort: true, value: "sku_no" },
          { headName: "SKU Description", isSort: true, value: "description" },
          { headName: "Min. Stock Level", isSort: true, value: "min_qty" },
          { headName: "UOM", isSort: true, value: "master_uom_name" },
          {
            headName: "Average Lead Time",
            isSort: true,
            value: "lead_time_in_days",
          },
          { headName: "Action", isSort: false, value: "Action" },
        ]}
        tClass="table-fixed w-full border-separate border-spacing-y-2"
        hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[--bg-color-50]"
        bClass="text-sm"
        thClass={`px-2 py-3 whitespace-nowrap text-left font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4`}
        setSort={setSort}
        sort={sort}
      >
        {tableLoader ? (
          <tr className="px-2 py-3 whitespace-nowrap">
            <td colSpan={7}>
              <div className="flex justify-center p-2 my-2 whitespace-nowrap w-full">
                <Loader show={tableLoader} />
              </div>
            </td>
          </tr>
        ) : sku_data_list?.data?.length > 0 ? (
          sku_data_list.data.map((element, index) => {
            const {
              sku_name,
              sku_no,
              description,
              min_qty,
              master_uom,
              lead_time_in_days,
            } = element;
            const uom_data = master_uom.master_uom_name;
            return (
              <TableRow
                key={index}
                row={{
                  sku_name,
                  sku_no,
                  description,
                  min_qty,
                  uom_data,
                  lead_time_in_days,
                }}
                tdClass="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left bg-[--bg-color-50] first:rounded-l-md last:rounded-r-md max-w-1/4 truncate"
              >
                <td className="px-2 py-2 whitespace-nowrap text-center text-sm bg-[--bg-color-50] rounded-r-md leading-4 tracking-tight text-[--bg-color-500] font-semibold">
                  <div className="space-x-3 flex items-center justify-start">
                    <div title="Edit">
                      <span
                        className="fa-light fa-pen text-base cursor-pointer"
                        style={{ color: "#9297a2" }}
                        onClick={() =>
                          navigate("/sku/update", { state: element })
                        }
                      ></span>
                    </div>
                    <div title="Delete">
                      <span
                        className="fa-light fa-trash-can text-base cursor-pointer"
                        style={{ color: "#eb5757" }}
                        onClick={() => {
                          swal({
                            content: (
                              <CustomeModal
                                type="delete"
                                title="Are you sure?"
                                content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                                onDelete={() =>
                                  handleDelete(element.sku_master_id)
                                }
                              />
                            ),
                            buttons: false,
                            closeOnClickOutside: false,
                            closeOnEsc: false,
                          });
                        }}
                      ></span>
                    </div>
                  </div>
                </td>
              </TableRow>
            );
          })
        ) : (
          <tr className="px-2 py-3 whitespace-nowrap">
            <td
              colSpan={7}
              className="text-center py-2 text-lg text-[#1E293B] tracking-tight leading-4"
            >
              There are no records to display
            </td>
          </tr>
        )}
      </Table>
      {!tableLoader && (
        <div className="flex justify-between items-center">
          <RowsPerPageSelector />
          <PageSelector
            rowPerPage={row_count}
            page={page}
            setpage={(newPage) => {
              setPage(newPage);
            }}
            totalDataCount={sku_data_list ? sku_data_list.totalCount : 0}
          />
        </div>
      )}
    </div>
  );
}

export default SKUTable;
